import { getDefaultStore } from 'jotai';

import { currentDemoSessionIdAtom } from '../atoms/demoFlowAtoms';

/**
 * GRO-3186 / analytics separation: returns `'shortened'` when `sessionId`
 * matches the user's current shortened-demo session (set in
 * `DemoEntryPointOverlay` when the user clicks "Try a demo"), or `undefined`
 * for every other session.
 *
 * Used to tag analytics events (frontend transcription/note events and the
 * `demo_mode` field sent on consult-note generation requests) so demo notes can
 * be separated from real ones — the backend forwards this onto the
 * `consult_note_generation` event so demo generations don't inflate metrics.
 *
 * `getDefaultStore()` is resolved lazily so callers can be tested without
 * booting Jotai at module init. Reads from sessionStorage so reloads inside the
 * demo session still tag correctly; returns `undefined` if Jotai or storage are
 * unavailable (SSR, etc.). Never throws.
 */
export function getDemoModeForSession(
  sessionId: string | undefined
): 'shortened' | undefined {
  if (!sessionId) return undefined;
  try {
    const demoSessionId = getDefaultStore().get(currentDemoSessionIdAtom);
    return demoSessionId && demoSessionId === sessionId ? 'shortened' : undefined;
  } catch {
    return undefined;
  }
}
